<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>用户审核</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          label-width="68px"
          style="margin-left: 8vh"
        >
          <el-form-item style="margin-bottom: 0">
            <el-select
              v-model="searchForm.apply_status"
              placeholder="审核状态"
              clearable
              size="small"
              @change="searchChange"
              @clear="clearInput"
            >
              <el-option
                v-for="item in status"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange"
              size="small"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="medium"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="realname" label="名称" align="center" />
      <el-table-column label="电话号码" align="center">
        <template slot-scope="scope">
          <span class="mobiles" @click.stop="details(scope.row)">{{
            scope.row.mobile
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="xiaoqu_name" label="小区名" align="center" />
      <el-table-column
        prop="build_title"
        label="楼栋名"
        align="center"
        width="120"
      />
      <el-table-column prop="room_title" label="房间号" align="center" />
      <el-table-column prop="created_at" label="提交时间" align="center" />
      <el-table-column prop="apply_time" label="审核时间" align="center" />
      <el-table-column prop="apply_status" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.apply_status == 1" type="success" size="mini"
            >审核通过</el-tag
          >
          <el-tag v-if="scope.row.apply_status == 0" type="warning" size="mini"
            >审核中</el-tag
          >
          <el-tag v-if="scope.row.apply_status == -1" type="danger" size="mini"
            >拒绝</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="审核" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="successClick(scope.row)"
            type="success"
            icon="el-icon-success"
            size="small"
            v-if="scope.row.apply_status !== 1"
          >
            通过
          </el-button>
          <el-button
            @click.native.prevent="refuse(scope.row, scope.row.id)"
            type="danger"
            icon="el-icon-error"
            size="small"
            v-if="scope.row.apply_status !== -1"
          >
            拒绝
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.pageSize"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="95%"
      class="global-dialog-position"
      :before-close="getout"
      top="5vh"
      :lock-scroll="false"
      :append-to-body="true"
    >
      <el-row v-loading="loading">
        <el-col :span="13">
          <h4 class="info-title">用户信息:</h4>
          <el-descriptions class="margin-top" :column="3" size="medium" border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                用户名
              </template>
              {{ userInfo.realname }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                手机号
              </template>
              {{ userInfo.mobile }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                停留时间
              </template>
              {{ userInfo.stay_second }}s
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                登录次数
              </template>
              {{ userInfo.login_times }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                备注
              </template>
              {{ userInfo.content }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                禁用启用小区
              </template>
              <el-switch v-model="isStatusTrue"></el-switch>
            </el-descriptions-item>
          </el-descriptions>
          <h4 class="info-title">
            小区权限:<el-select
              v-model="xiaoquValue"
              filterable
              placeholder="搜索小区"
              size="small"
              style="margin-left: 2vh"
              @change="selectXiaqou"
              @visible-change="valueChange($event)"
            >
              <el-option
                v-for="item in regions"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </h4>
          <!-- <el-button type="success" @click="allClick">一键全选</el-button> -->
          <div style="display: flex; flex-wrap: wrap; gap: 10px">
            <div
              v-for="(button, index) in regions"
              :key="index"
              style="display: flex; align-items: center; flex-basis: 25%"
            >
              <el-button
                v-model="selectedButton"
                :type="selectedButton === index ? 'primary' : 'default'"
                :plain="selectedButton !== index"
                @click="selectButton(index, button.id)"
                style="flex-grow: 1"
              >
                {{ button.id }}
                {{ button.title }}
              </el-button>
              <el-checkbox
                v-model="button.check"
                class="checkbox"
                style="align-self: center"
                @change="handleCheckboxChange(button.id, userInfo.id)"
              ></el-checkbox>
            </div>
          </div>
          <el-divider></el-divider>
          <h4 class="info-title">用户标签:</h4>
          <div style="display: flex; gap: 10px">
            <el-tag
              v-for="(tags, index) in userTag"
              :key="index"
              effect="plain"
              >{{ tags }}</el-tag
            >
          </div>
          <el-divider></el-divider>
          <h4 class="info-title">锁定:</h4>
          <div style="display: flex; gap: 10px; flex-wrap: wrap">
            <el-tag
              v-for="(lock, index) in userLock"
              :key="index"
              effect="plain"
              >{{ lock.carport_title }}</el-tag
            >
          </div>
          <el-divider></el-divider>
          <h4 class="info-title">用户收藏:</h4>
          <div style="display: flex; gap: 10px; flex-wrap: wrap">
            <el-tag
              v-for="(userLikes, index) in userLike"
              :key="index"
              effect="plain"
              >{{ userLikes.carport_title }}</el-tag
            >
          </div>
        </el-col>
        <el-col :span="11">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in displayUserFollow"
              :key="index"
              :timestamp="item.created_at"
              placement="top"
            >
              <el-card>
                <h4>
                  购买想法:
                  <span style="color: #409eff">{{ item.intention_tag }}</span>
                </h4>
                <p>
                  <el-row>
                    <el-col :span="12">
                      备注:
                      <span style="color: #e6a23c">{{ item.content }}</span>
                    </el-col>
                    <el-col :span="12">
                      跟进阶段:<span style="color: #e6a23c">{{
                        item.stage_tag
                      }}</span>
                    </el-col>
                  </el-row>
                </p>
                <div style="display: flex; gap: 10px">
                  <el-image
                    v-for="(image, index) in item.imgs"
                    :key="index"
                    style="width: 100px; height: 100px"
                    :src="`${image}`"
                    :preview-src-list="item.imgs"
                  ></el-image>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          <!-- 分页 -->
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[3, 6, 9, 12]"
            :total="userFollow.length"
            background
            :page-size="pageSize"
            layout="sizes, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
  
  <script>
import tableCommon from "../../../mixins/table-common";
import {
  getmembersList,
  editmember,
  getmemberInfo,
  editmemberMake,
  editmemberPower,
} from "../../api/member";
export default {
  mixins: [tableCommon],
  data() {
    return {
      //状态
      status: [
        {
          id: 0,
          name: "审核中",
        },
        {
          id: -1,
          name: "拒绝",
        },
      ],
      // 请求地址api
      api: {
        list: getmembersList,
      },
      data: [
        {
          id: 0,
          mid: 0,
          xiaoqu_id: 0,
          realname: "string",
          mobile: "string",
          build_title: "string",
          room_title: "string",
          apply_status: 0,
          xiaoqu_name: "string",
        },
      ],
      // 传参
      form: {
        status: "1",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        pageSize: 15,
        apply_status: 0,
      },
      tableData: [],
      // 用户信息列表
      userInfo: {},
      // 小区列表
      regions: [],
      // 用户标签
      userTag: "",
      // 用户收藏
      userLike: [],
      // 用户跟进
      userFollow: [],
      // 用户id
      userId: "",
      // 用户锁定
      userLock: [],
      // 小区id
      regionArr: [],
      xiaoqu_userId: "",
      userForms: {},
      pageSize: 3,
      loading: true,
      currentPage: 1,
      selectedButton: 0,
      xiaoquValue: "",
    };
  },
  mounted() {},
  computed: {
    displayUserFollow() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.userFollow.slice(startIndex, endIndex);
    },
    isStatusTrue: {
      get() {
        return this.userInfo.status == 1 ? true : false;
      },
      set(value) {
        this.userInfo.status = value ? 1 : 0;
        const makeForm = {
          id: this.userId,
        };
        editmemberMake(makeForm).then((res) => {});
      },
    },
  },
  methods: {
    async valueChange(e) {
      console.log(e);
      if (e == true) {
        await getmemberInfo(this.userForms).then((res) => {
          if (res.code !== 200) return this.$message.error("请求失败");
          this.regions = res.data.xiaoqus;
        });
      }
    },
    // 选择小区
    async selectXiaqou(e) {
      const filteredRegions = this.regions.filter((item) => item.id === e);
      this.regions = filteredRegions;
      console.log(filteredRegions);
    },
    // 选中小区
    handleCheckboxChange(res, req) {
      const checkData = {
        id: req,
        xiaoqu_id: res,
      };
      editmemberPower(checkData).then((res) => {});
    },
    async selectButton(index, id) {
      this.selectedButton = index;
      if (id) {
        const regionForm = {
          xiaoqu_id: id,
          mid: this.userId,
        };
        await this.details(regionForm);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    //查看详情
    details(req) {
      this.title = "详情";
      this.userId = req.mid;
      this.userForms = req;
      this.userForms.id = req.mid;
      this.addOrEditOpen = true;
      getmemberInfo(this.userForms).then((res) => {
        if (res.code !== 200) return this.$message.error("请求失败");
        this.userInfo = res.data.member;
        this.regions = res.data.xiaoqus;
        this.userTag = res.data.tag;
        this.userLike = res.data.sc;
        this.userFollow = res.data.follow.reverse();
        this.userLock = res.data.lock;
        this.xiaoqu_userId = res.data.xiaoqu_id;
        let index = this.regions.findIndex(
          (item) => item.id === parseInt(this.xiaoqu_userId)
        );
        this.selectButton(index);
        setTimeout(() => {
          this.loading = false;
        }, 300);
      });
    },
    // 点击清空事件
    clearInput() {
      (this.searchForm = {
        page: 1,
        pageSize: 15,
      }),
        this.initList();
    },
    // 审核通过
    successClick(res) {
      const memberForm = {
        id: res.id,
        apply_status: 1,
      };
      // res.apply_status = "1";
      this.$confirm("确定审核通过？", "审核通过", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        editmember(memberForm).then((res) => {
          if (res.code !== 200)
            return this.$message.error(res.msg ? res.msg : "操作失败!");
          this.$message.success("操作成功");
          this.initList();
        });
      });
    },
    // 拒绝
    refuse(res) {
      const memberForm = {
        id: res.id,
        apply_status: -1,
      };
      // res.apply_status = "-1";
      this.$confirm("确定拒绝？", "拒绝", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        editmember(memberForm).then((res) => {
          if (res.code !== 200)
            return this.$message.error(res.msg ? res.msg : "操作失败!");
          this.$message.success("操作成功");
          this.initList();
        });
      });
    },
    // 新增弹窗
    handleNewAdd() {
      //   this.title = "新增";
      //   this.reset();
      //   this.handleAdd();
      this.tableList = this.data;
    },
    getout() {
      this.addOrEditOpen = false;
      this.selectButton(0); // 默认选中第一个按钮
      this.loading = true;
      this.xiaoquValue = "";
    },
    // 重置
    resets() {
      this.searchForm = {
        title: undefined,
      };
      this.initList();
    },
  },
};
</script>
<style scoped>
/deep/.el-loading-mask {
  top: 20%;
}
/deep/ .el-dialog__body {
  height: 75vh;
  overflow-y: auto;
}
/deep/ .remarkDag .el-dialog__body {
  height: 30vh;
  overflow-y: auto;
}
.checkbox {
  zoom: 280%;
  margin: -2px 0 0 1px;
}
.mobiles {
  color: #409eff;
  cursor: pointer;
  transition: color 0.3s ease;
}
.mobiles:hover {
  color: #000;
}
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/member/member.vue